























import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SortOrder } from '@/enums/SortOrder';
import { Debounce } from '@/functions/debounce';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
    IndexSearch: () => import('@/components/parts/IndexSearch.vue'),
  },
})
export default class PageCollections extends Searchable<Collection> {
  @Getter('collection/all') collections!: Collection[];

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('collection/index') indexCollections!: (payload?: { query?: IndexQuery<Collection>; workspaceId: number }) => Promise<Collection[]>;

  i18n: string = 'views.collections.index';

  localCollections: Collection[] = [];

  searchItemsProperty = 'collections';

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 136px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Collection) => `#${model.id}`,
        width: 75,
      },
      { key: 'name', width: 350 },
      { key: 'ordinal', width: 120 },
      {
        key: 'status',
        style: (model: Collection) => {
          if (model.status === 'published') {
            return {
              color: 'var(--color-green)',
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '15px',
              padding: '2px 6px',
              borderRadius: '2px',
              backgroundColor: 'var(--color-green)20',
              border: '1px solid var(--color-green)90',
            };
          } else {
            return {
              color: '#6C727A',
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '15px',
              padding: '2px 6px',
              borderRadius: '2px',
              backgroundColor: '#F5F5F5',
              border: '1px solid #DEDFE3',
            };
          }
        },
      },
      {
        key: 'products_total',
        width: 130,
      },
    ],
  };

  @Debounce(500)
  handleSearch(searchText: string) {
    this.searchText = searchText;
    this.indexCollections({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  loadMore() {
    this.indexCollections({ query: { q: this.searchQuery, per_page: 20, after: this.lastAfter, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  handleSort(item: any) {
    this.sorting = item;
    this.indexCollections({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  @Watch('collections', { immediate: true })
  collectionsChanged(val: Collection[]) {
    this.localCollections = val;
  }
  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.indexCollections({ workspaceId: val.id });
  }
}
